module.exports = __webpack_public_path__ + "img/login-page-art.db354589.svg";